import {NextRouter} from 'next/router'

export const removeQueryParamsFromRouter = async (router: NextRouter, removeList: string[]) => {
  removeList.forEach(param => delete router.query[param])
  await router.replace(
    {
      pathname: router.pathname,
      query: router.query,
    },
    undefined,
    {shallow: true}
  )
}
